import { getProblemDetail } from '@/lib/utils/apiErrors';

export type SupportInfo = {
  url?: string;
  status?: number;
  statusText?: string;
  tokenExpiration?: string | null;
  requestId?: string;
  traceparent?: string;
  date?: string;
  timestamp?: string;
  /** Selected role name (for support context) */
  role?: string;
};

export function extractSupportInfo(error: unknown): SupportInfo | undefined {
  const e = error as any;
  return (
    (e?.supportInfo as SupportInfo | undefined) ?? (e?.result?.supportInfo as SupportInfo | undefined) ?? undefined
  );
}

/**
 * Formats an error for the persistent grid/search snackbar.
 * Uses the backend's ProblemDetails detail as the message so users see the real reason,
 * and attaches supportInfo (request ID, trace) for the "Details" action.
 */
export function formatPersistentSnackbarError(error: unknown): {
  message: string;
  supportInfo?: SupportInfo;
} {
  return {
    message: getProblemDetail(error) ?? 'An error occurred. Please try again.',
    supportInfo: extractSupportInfo(error),
  };
}
